import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/hotspot/logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-55e07ba4")

_pushScopeId("data-v-55e07ba4")
const _hoisted_1 = { class: "logo-wrapper-bg" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "logo-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "logo-wrapper",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)), ["stop","prevent"]))
    }, [
      _hoisted_2,
      _createVNode("div", _hoisted_3, [
        _createVNode("span", null, _toDisplayString(_ctx.text), 1)
      ])
    ])
  ]))
})